import { UntypedFormControl, ValidationErrors } from "@angular/forms";

function controlHasValue(control: UntypedFormControl) {
  return control && control.value && control.value.length > 0;
}

export function lowercaseValidator(control: UntypedFormControl): ValidationErrors {
  if (controlHasValue(control)) {
    return /[a-z]/.test(control.value) ? null : { lowerCase: true };
  }
  return null;
}

export function uppercaseValidator(control: UntypedFormControl): ValidationErrors {
  if (controlHasValue(control)) {
    return /[A-Z]/.test(control.value) ? null : { uppercase: true };
  }
  return null;
}

export function numberValidator(control: UntypedFormControl): ValidationErrors {
  if (controlHasValue(control)) {
    return /[0-9]/.test(control.value) ? null : { number: true };
  }
  return null;
}

export function specialValidator(control: UntypedFormControl): ValidationErrors {
  if (controlHasValue(control)) {
    return /[@$%!^&*()_+{}:;<>,.?~]/.test(control.value)
      ? null
      : { special: true };
  }
  return null;
}

export function minlengthValidationMessages(_err, field) {
  if (field && field.validation && field.validation.messages && field.validation.messages.minLength) {
    return field.validation.messages.minLength;
  }
  return "";
}

export function maxlengthValidationMessages(_err, field) {
  if (field && field.validation && field.validation.messages && field.validation.messages.maxLength) {
    return field.validation.messages.maxLength;
  }
  return "";
}

export function requiredValidationMessages(_err, field) {
  if (field && field.validation && field.validation.messages && field.validation.messages.required) {
    return field.validation.messages.required;
  }
  return "";
}